<template>
  <div style="min-height: 0.5rem" v-show="shows">
    <div class="gzgzh">
      <div class="sygzbg">
        <div style="background: #fff;">
          <img src="../assets/img/s_logo.png"/>
        </div>
        <div>
          <span>关注公众号</span>
          <span>选购医学护肤产品请识别二维码</span>
        </div>
      </div>
      <div class="btngz" @click="showgzbg">立即识别</div>
    </div>
    <div class="gzbgindex" v-show="gzbgshow">
      <div class="remark_content">
        <div class="remark">
          <div class="banner">
            <img src="../assets/img/bggzpg.png"/>
          </div>
          <div class="lserm">
            <img src="../assets/img/erweima.jpg"/>
          </div>
          <div class="text">长按图片，识别二维码关注公众号</div>
        </div>
        <div class="close" @click="closegzbg">
          <img src="../assets/img/gzclose.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "focuson",
      data(){
          return {
            shows: false,
            gzbgshow: false
          }
      },
      methods:{
        /*
         * 获取cookie
         */
        getCookie:function (name) {
          var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

          if (arr = document.cookie.match(reg))

            return unescape(arr[2]);
          else
            return null;
        },
        getQueryString: function (name) {
          var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
          var r = window.location.search.substr(1).match(reg);
          if (r != null) return unescape(r[2]);
          return null;
        },
        /*
         * 设置cookie
         */
        setCookie:function (name, value) {
          var Days = 1;
          var exp = new Date();
          exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
          document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
        },
        showgzbg:function () {
          var that = this;
          // that.setCookie('subscript','');
          // console.log('清除关注缓存');
          // console.log(that.getCookie('subscript'));
          setTimeout(function(){
            that.gzbgshow = true;
            // $('.gzbgindex').show();
          },500);
        },
        closegzbg:function () {
          this.gzbgshow = false;
          // $('.gzbgindex').hide();
        },
      },
      mounted() {
        var wxToken = localStorage.getItem('ACCESS_TOKE');
        var params = new URLSearchParams();
        params.append('code', wxToken);
        // if(!!this.getCookie('subscript') && !!code){
        //   console.log('有关注缓存');
        //   console.log(this.getCookie('subscript'));
        //   if(this.getCookie('subscript')=='0'){
        //     this.shows = true;
        //   }
        // }else{
          this.$axios.post('/api/consumer-member/wx/userInfo/getMemberByCode',
            params)
            .then(res=>{
              if(res.data.code=='10000'){
                // console.log('存储关注缓存');
                // this.setCookie('subscript',res.data.result.subscript);
                if(res.data.result.subscribe=='0'){
                  this.shows = true;
                }
                // else if(res.data.result.subscript=='1' ){
                //   localStorage.removeItem('code');
                // }
              }
            })
          // $.ajax({
          //   url:'/userInfo/getMemberByCode',
          //   type: 'POST',
          //   data:{code:wxToken},
          //   success:function (data) {
          //     if(data.code==200){
          //       console.log('存储关注缓存');
          //       this.setCookie('subscript',data.result.subscript);
          //       if(data.result.subscript=='0'){
          //         this.shows = true;
          //       }
          //     }
          //   }
          // })
        // }
      }
    }
</script>

<style scoped>
  .gzgzh {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    width: 100%;
    height: 50px;
    background: #242f47;
    position: fixed;
    z-index: 9;
  }
  .sygzbg {
    float: left;
    height: 50px;
    padding: 6px 8px;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    color: #fff;
    -prefix-box-flex: 1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }
  .sygzbg div:nth-child(1) {
    width: 40px;
    display: block;
    border: 0;
    margin-right: 5px;
  }
  .sygzbg div:nth-child(1) img {
    width: 100%;
    display: block;
    height: 40px;
  }
  .sygzbg div:nth-child(2) {
    -prefix-box-flex: 1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -moz-justify-content: center;
    -webkit-justify-content: center;
    justify-content: center;
    font-size: 12px;
  }
  .sygzbg div:nth-child(2) span {
    width: 100%;
    display: block;
  }
  .sygzbg div:nth-child(2) span:nth-child(1) {
    width: 100%;
    display: block;
    margin-bottom: 2px;
  }
  .sygzbg div:nth-child(2) span:nth-child(2) {
    width: 100%;
    display: block;
    opacity: .6;
  }
  .btngz {
    color: #fff;
    width: 27%;
    float: right;
    height: 50px;
    line-height: 50px;
    background: #2fc2a8;
    text-align: center;
    font-size: 14px;
  }
  .gzbgindex {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: 10000;
    background: rgba(0,0,0,0.54);
  }
  .gzbgindex .remark_content {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    justify-content: center;
    -webkit-box-align: center;
    -moz-align-items: center;
    -webkit-align-items: center;
  }
  .gzbgindex .remark {
    background: #fff;
    width: 80%;
    margin: 0 auto;
    padding: 21px;
    overflow: hidden;
  }
  .gzbgindex .remark .banner {
    width: 70%;
    margin-bottom: 30px;
  }
  .gzbgindex .close img, .gzbgindex .remark .banner img, .gzbgindex .remark .lserm img {
    width: 100%;
    display: block;
    border: 0;
  }
  .gzbgindex .remark .lserm {
    width: 85%;
    margin: 0 auto;
    margin-bottom: 28px;
  }
  .gzbgindex .remark .text {
    text-align: center;
    color: #333;
    font-size: 16px;
  }
  .gzbgindex .close {
    width: 37px;
    height: 37px;
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/focuson/focuson.vue